export enum AvatarSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  HUGE = 'huge',
}

export enum AvatarButtonDisplayFormat {
  TILE = 'tile',
  CIRCLE = 'circle',
}
